import {RESOURCE_CONFIG} from "../../model/resource.js";

/**
 * @typedef {import("../../model/resource").ResourceElement} ResourceElement
 */

/**
 * @param {ResourceElement} resource
 */
export const callConfig = (resource) => {
  const callbacks = resource[RESOURCE_CONFIG];
  if (!callbacks) {
    return false;
  }

  let configHasChanged = false;

  for (const callback of callbacks) {
    configHasChanged ||= !!callback(resource);
  }

  return configHasChanged;
};
